module.exports = __webpack_public_path__ + "static/media/process.9b273cd2.png";